<template>
  <div class="q-mx-auto q-my-xl" style="max-width: 1000px">
    <h5 class="text-h5">Historical documentation Annotator</h5>
    <p class="text-subtitle1 text-grey-7">
      Annotate text for analysis of historical document
    </p>

    <div class="q-pa-md">
      <div class="q-gutter-md row items-start">
        <div class="q-gutter-md column items-start">
          Historical document(XML file)
          <input
            ref="input"
            type="file"
            accept=".xml"
            multiple
            @change="selectedFile()"
          />
        </div>
        <div class="q-gutter-md column items-start">
          Person list(csv file) ※option
          <input
            ref="person_input"
            type="file"
            accept=".csv"
            multiple
            @change="selectedFile()"
          />
        </div>
        <div class="q-gutter-md column items-start">
          kani list(csv file) ※option
          <input
            ref="kani_input"
            type="file"
            accept=".csv"
            multiple
            @change="selectedFile()"
          />
        </div>
        <!--
        <q-file
          v-model="xml_file"
          label="XML file"
          filled
          counter
          multiple
          accept=".xml"
          bg-color="light-blue-1"
          style="width: 250px"
        >
          <template v-slot:prepend>
            <q-icon name="fas fa-upload" />
          </template>
        </q-file>

        <q-file
          v-model="person_csv"
          label="Person list(option)"
          filled
          counter
          multiple
          accept=".csv"
          bg-color="light-blue-1"
          style="width: 250px"
        >
          <template v-slot:prepend>
            <q-icon name="fas fa-upload" />
          </template>
        </q-file>

        <q-file
          v-model="kani_csv"
          label="kani list(option)"
          filled
          counter
          multiple
          accept=".csv"
          bg-color="light-blue-1"
          style="width: 250px"
        >
          <template v-slot:prepend>
            <q-icon name="fas fa-upload" />
          </template>
        </q-file>-->
      </div>
      <div class="q-pa-md float-right q-gutter-sm">
        <q-btn
          outline
          color="primary"
          label="Upload"
          type="submit"
          @click="uploadSelectedFile()"
        />
        <q-btn
          outline
          color="secondary"
          label="Start Annotation"
          @click="startNER()"
        />
        <q-btn
          outline
          color="secondary"
          label="test"
          @click="startAnnotation_test()"
        />
      </div>
    </div>
  </div>
  <q-separator />
  <div class="bg-grey-1 q-pa-lg">
    <div class="q-mx-auto" style="max-width: 600px">
      <h4 class="text-h4">
        How to use the Historical documentation Annotator?
      </h4>
      <q-timeline>
        <q-timeline-entry
          subtitle="Step 1"
          title="Load your files with contents to annotate"
          icon="fa fa-upload"
          color="yellow-8"
        >
          <q-img
            src="@/assets/step1-1.png"
            spinner-color="white"
            class="rounded-borders"
            style="border: 1px solid #ccc; width: 80%"
          />
          <p class="text-subtitle1 q-my-md">About Input file</p>
          <ul>
            <li>XML file: Historical document xml file you want to annotate</li>
            <li>
              Person list: Table of correspondence between persons and positions
              in the documents(Option)
            </li>
            <li>
              Kani list: List of positions(Kani) in the document
            </li>
          </ul>
          <p class="text-subtitle1 q-my-md">Then, push "UPLOAD"</p>
          <p class="text-subtitle1 q-my-md">
            After that, push "START ANNOTATION"!
          </p>
        </q-timeline-entry>
        <q-timeline-entry
          subtitle="Step 2"
          title="Start correction of NER result"
          icon="fa fa-tag"
          color="orange-6"
        >
          <q-img
            src="@/assets/step1-2.png"
            spinner-color="white"
            class="rounded-borders"
            style="border: 1px solid #ccc"
          />
          <ul class="q-my-md">
            <li>
              The results of automatic annotation are displayed.Blue is a person
              and red is a word
            </li>
            <li>Please click on the x to correct any mistakes.</li>
            <li>
              Click the <strong>Save</strong> button once you are done
              annotating an entry and to move to the next one
            </li>
          </ul>
        </q-timeline-entry>
        <q-timeline-entry
          subtitle="Step 3"
          title="Download your annotations as a XML file that can be used for analysis tools"
          icon="fa fa-download"
          color="red-6"
        >
          <q-img
            src="@/assets/step1-3.png"
            spinner-color="white"
            class="rounded-borders"
            style="border: 1px solid #ccc; width: 70%"
          />
        </q-timeline-entry>

        <q-timeline-entry
          subtitle="Finally"
          title="Use XML file as Input of analysis tools"
          icon="fa fa-file"
          color="red-10"
        >
          <!--<p>
            See the spaCy documentation
            <a href="https://spacy.io/api/data-formats#json-input">here</a> on
            how to convert the annotations from JSON to DocBin format.
          </p>-->
        </q-timeline-entry>
      </q-timeline>
    </div>
  </div>
  <q-dialog v-model="screenStatus">
    <q-card>
      <q-card-section>
        <div class="text-h6">Loading...</div>
      </q-card-section>

      <q-card-section class="q-pt-none">
        <h3>Loading: {{ stage_percentage }}％</h3>
        <h3>Remaining Time: {{ remaining_time }}min</h3>
      </q-card-section>

      <!--<q-card-actions align="right">
        <q-btn flat label="OK" color="primary" v-close-popup />
      </q-card-actions>-->
    </q-card>
  </q-dialog>

  <div class="q-my-xl q-py-md">
    <q-file
      v-model="textFile"
      accept=".txt"
      filled
      @update:model-value="onFileSelected"
      label="Open a text file to begin"
      bg-color="light-blue-1"
    >
      <template v-slot:prepend>
        <q-icon name="fas fa-upload" />
      </template>
    </q-file>
  </div>
</template>

<script>
import { mapMutations } from "vuex";
import { ref } from "vue";
import { Auth, Storage } from "aws-amplify";
import axios from "axios";
import {LOGINID, LOGINPW} from "../store/const";

export default {
  name: "StartPage",
  emits: ["file-loaded"],
  data() {
    return {
      textFile: null,
      files: ref(null),
      xml_file: null,
      person_csv: null,
      kani_csv: null,
      taskid: "",
      screenStatus: false,
      stage_percentage: 0,
      remaining_time: 0,
      timerObj: null,
      mtg_info: {},
      file: null,
      loginid: null,
      loginpw: null
    };
  },
  mounted: async function() {
    this.login();
  },
  methods: {
    async selectedFile() {
      const file = this.$refs.input.files;
      const person_file = this.$refs.person_input.files;
      const kani_file = this.$refs.kani_input.files;
      if (file) {
        this.xml_file = file[0];
        console.log(file);
      }
      if (person_file) {
        this.person_csv = person_file[0];
      }
      if (kani_file) {
        this.kani_csv = kani_file[0];
      }
    },

    login() {
      console.log("login");
      this.loginid = LOGINID
      this.loginpw = LOGINPW
      Auth.signIn(this.loginid, this.loginpw)
        .then((data) => {
          if (data.challengeName == "NEW_PASSWORD_REQUIRED") {
            console.log("new password required.");
            data.completeNewPasswordChallenge(
              this.loginpw,
              {},
              {
                onSuccess(result) {
                  console.log("onSuccess");
                  console.log(result);
                },
                onFailure(err) {
                  console.log("onFailure");
                  console.log(err);
                },
              }
            );
          }
          console.log("login successfully.");
        })
        .catch((err) => {
          console.log("login failed.");
          console.log(err);
        });
    },

    ...mapMutations(["setInputSentences"]),
    onFileSelected(file) {
      let reader = new FileReader();
      reader.addEventListener("load", (event) => {
        this.setInputSentences(event.target.result);
        this.$emit("file-loaded");
      });
      reader.readAsText(file);
    },
    startNER: async function() {
      // const myInit = {
      //   headers: {
      //     "content-type": "application/json",
      //     "Access-Control-Allow-Origin": "*"
      //   },
      //   queryStringParameters: {
      //     taskid: this.taskid
      //   }
      // };
      console.log("start batch");
      // とりあえずurlで叩く
      // this.taskid = "task221117195100-139ecf717ac"
      console.log(
        "https://l3prfnels1.execute-api.ap-northeast-1.amazonaws.com/devlite/call_batch/" +
          this.taskid
      );
      const response = await fetch(
        "https://l3prfnels1.execute-api.ap-northeast-1.amazonaws.com/devlite/call_batch/" +
          this.taskid
      );
      // const response = await API.get("TodoApiFunction-devlite", "/call_batch/" + this.taskid);
      console.log(response);
      this.screenStatus = true; //timer起動
      this.start_time();
    },

    // batch後定期的にs3を確認する処理(10秒ずつ)
    start_time: function() {
      this.timerObj = setInterval(this.watch_s3, 10000);
      this.screenStatus = true; //timerがONであることを状態として保持
    },
    stop_time: function() {
      clearInterval(this.timerObj);
      this.screenStatus = false; //timerがOFFであることを状態として保持
    },

    watch_s3: function() {
      console.log("watch!");
      // mtg_infoの情報を取得
      this.get_mtg_file(() => {
        this.remaining_time = this.timerObj;
        // if (this.stage == 8) {
        //   this.screenStatus = 2;
        //   // this.getUrl("calibration.csv", (result) => {
        //   //   this.calibration_url = result;
        //   // });
        //   this.result_text = this.mtg_info["text"];
        //   this.downloadfilelist = this.mtg_info["downloadfilelist"];
        //   this.getUrl(this.mtg_info["displayfile"], result => {
        //     this.diagram_url = result;
        //   });
        // }
        if (this.mtg_info["status"] == "Done") {
          this.stop_time;
          this.startAnnotation();
        }
      });
    },
    get_mtg_file: function(callback) {
      const dataExpireSeconds = 60;
      // const tmp_mtgId = "d1e14412-4012-428c-af84-cfa0ef53b8d0";
      Storage.get(this.taskid + "/mtg_info.json", {
        level: "public",
        expires: dataExpireSeconds,
      })
        .then((url) => {
          axios.get(url).then((result) => {
            console.log(result);
            this.mtg_info = result.data;
            this.stage_percentage = this.mtg_info["percent"];
            callback();
          });
        })
        .catch((err) => {
          console.log(err);
        });
    },
    startAnnotation: async function(callback) {
      const dataExpireSeconds = 60;
      // const tmp_mtgId = "d1e14412-4012-428c-af84-cfa0ef53b8d0";
      // this.taskid = "task221128083615-ebab1fcb28";
      Storage.get(this.taskid + "/result.txt", {
        level: "public",
        expires: dataExpireSeconds,
      })
        .then((url) => {
          axios.get(url).then((result) => {
            Storage.get(this.taskid + "/result.json", {
              level: "public",
              expires: dataExpireSeconds,
            })
              .then((url) => {
                axios.get(url).then((result2) => {
                  result2 = result2.data
                  this.setInputSentences(result.data);
                  this.$store.commit("setResultAnnotations", result2);
                  console.log(this.$store.state.inputSentences);
                  console.log(this.$store.state.annotations)
                  this.$emit("file-loaded");
                  callback();
                });
              })
              .catch((err) => {
                console.log(err);
              });
          });
        })
        .catch((err) => {
          console.log(err);
        });
    },

    startAnnotation_test: async function(callback) {
      const dataExpireSeconds = 60;
      // const tmp_mtgId = "d1e14412-4012-428c-af84-cfa0ef53b8d0";
      this.taskid = "task230110231031-171b298248";
      Storage.get(this.taskid + "/result.txt", {
        level: "public",
        expires: dataExpireSeconds,
      })
        .then((url) => {
          axios.get(url).then((result) => {
            Storage.get(this.taskid + "/result.json", {
              level: "public",
              expires: dataExpireSeconds,
            })
              .then((url) => {
                axios.get(url).then((result2) => {
                  result2 = result2.data
                  this.setInputSentences(result.data);
                  this.$store.commit("setResultAnnotations", result2);
                  console.log(this.$store.state.inputSentences);
                  console.log(this.$store.state.annotations)
                  this.$emit("file-loaded");
                  callback();
                });
              })
              .catch((err) => {
                console.log(err);
              });
          });
        })
        .catch((err) => {
          console.log(err);
        });
    },

    loadMtgInfo: function(callback) {
      const dataExpireSeconds = 60;
      // const tmp_mtgId = "d1e14412-4012-428c-af84-cfa0ef53b8d0";

      Storage.get(this.taskid + "/mtg_info.json", {
        level: "public",
        expires: dataExpireSeconds,
      })
        .then((url) => {
          this.axios.get(url).then((result) => {
            console.log(result);
            this.mtg_info = result.data;
            callback();
          });
        })
        .catch((err) => {
          console.log(err);
        });
    },

    selectFile() {
      if (this.$refs.input != undefined) {
        this.$refs.input.click();
      }
    },

    uploadSelectedFile() {
      console.log(this.xml_file);
      console.log(this.person_csv);
      // this.screenStatus = true;
      if (this.xml_file == undefined) {
        this.screenStatus = false;
        return;
      }

      let dt = new Date();
      this.task = "task" + this.getDirString(dt);
      this.taskid = this.task;
      let dirName = this.task;
      //upload xml file
      let filePath = dirName + "/" + "minkeiki.xml";
      console.log("upload");
      Storage.put(filePath, this.xml_file, {
        level: "public",
        contentType: "application/xml",
      })
        .then((result) => {
          console.log(result);
        })
        .catch((err) => console.log(err));
      if (this.person_csv == undefined) {
        this.screenStatus = false;
        return;
      }
      let filePath_person = dirName + "/" + "minkeiki_person_list.csv";
      Storage.put(filePath_person, this.person_csv, {
        level: "public",
        contentType: "text/csv",
      })
        .then((result) => {
          console.log(result);
        })
        .catch((err) => console.log(err));

      if (this.kani_csv == undefined) {
        this.screenStatus = false;
        return;
      }

      let filePath_kani = dirName + "/" + "kani.csv";
      Storage.put(filePath_kani, this.kani_csv, {
        level: "public",
        contentType: "text/csv",
      })
        .then((result) => {
          console.log(result);
        })
        .catch((err) => console.log(err));
      this.screenStatus = false;
    },

    getDirString(date) {
      let random = date.getTime() + Math.floor(100000 * Math.random());
      random = Math.random() * random;
      random = Math.floor(random).toString(16);
      return (
        "" +
        ("00" + date.getUTCFullYear()).slice(-2) +
        ("00" + (date.getMonth() + 1)).slice(-2) +
        ("00" + date.getUTCDate()).slice(-2) +
        ("00" + date.getUTCHours()).slice(-2) +
        ("00" + date.getUTCMinutes()).slice(-2) +
        ("00" + date.getUTCSeconds()).slice(-2) +
        "-" +
        random
      );
    },
  },
};
</script>

<style lang="scss" scoped></style>
